<div class="horizontal-field" 
     [attr.data-disabled]="disabled"
     [attr.data-error]="error">
  <div class="horizontal-field-label" [style.min-width]="labelWidth">
    <umss-label
      [text]="label"
      [htmlFor]="htmlFor"
      [required]="required"
      [disabled]="disabled"
      [error]="error"
      size="Regular"
      weight="Medium">
    </umss-label>
  </div>
  
  <div class="horizontal-field-content">
    <ng-content></ng-content>
  </div>
</div>